/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_VaultInputs */

const en_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Vault`)
};

const es_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda de documentos`)
};

const fr_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort de documents`)
};

const de_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenten-Vault`)
};

const ja_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメント保管庫`)
};

const zh_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档金库`)
};

const ar_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خزنة المستندات`)
};

const id_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Dokumen`)
};

const it_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault dei Documenti`)
};

const ru_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище документов`)
};

const pt_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre de Documentos`)
};

const ko_document_vault = /** @type {(inputs: Document_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서 보관소(Vault)`)
};

/**
* | output |
* | --- |
* | "Document Vault" |
*
* @param {Document_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_vault = /** @type {((inputs?: Document_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_vault(inputs)
	if (locale === "es") return es_document_vault(inputs)
	if (locale === "fr") return fr_document_vault(inputs)
	if (locale === "de") return de_document_vault(inputs)
	if (locale === "ja") return ja_document_vault(inputs)
	if (locale === "zh") return zh_document_vault(inputs)
	if (locale === "ar") return ar_document_vault(inputs)
	if (locale === "id") return id_document_vault(inputs)
	if (locale === "it") return it_document_vault(inputs)
	if (locale === "ru") return ru_document_vault(inputs)
	if (locale === "pt") return pt_document_vault(inputs)
	return ko_document_vault(inputs)
});